import React from 'react';
import PhotoThumb from '../PhotoThumb';
import useLaunchDarkly from 'hooks/useLaunchDarkly';

const BottleActivity = ({ activity }) => {
  const flags = useLaunchDarkly();
  const enableBottleType = flags['online-ent-bottlefeedingreport'];
  const { amount, desc, bottle_type, bottle_consumed } = activity.data;

  return (
    <div className="activity__bottle">
      {bottle_type && enableBottleType ? (
        <>
          <div className="activity__paragraph-bottle">{`Served ${amount} oz. ${desc}`}</div>
          { bottle_consumed && (<div className="activity__paragraph-bottle" data-testid="bottle_consumed">{`Consumed ${bottle_consumed} oz.`}</div>) }
          <div className="activity__paragraph-bottle-type" data-testid="bottle_type">{bottle_type}</div>
        </>
      ) : (
        <div className="activity__paragraph">{`${amount} oz. ${desc}`}</div>
      )}
      <PhotoThumb photoUrl={activity.photo_url} />
    </div>
  );
};

export default BottleActivity;
